var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.4375C11.7259 8.4375 13.125 7.03839 13.125 5.3125C13.125 3.58661 11.7259 2.1875 10 2.1875C8.27411 2.1875 6.875 3.58661 6.875 5.3125C6.875 7.03839 8.27411 8.4375 10 8.4375Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6875 16.5625C16.4134 16.5625 17.8125 15.1634 17.8125 13.4375C17.8125 11.7116 16.4134 10.3125 14.6875 10.3125C12.9616 10.3125 11.5625 11.7116 11.5625 13.4375C11.5625 15.1634 12.9616 16.5625 14.6875 16.5625Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3125 16.5625C7.03839 16.5625 8.4375 15.1634 8.4375 13.4375C8.4375 11.7116 7.03839 10.3125 5.3125 10.3125C3.58661 10.3125 2.1875 11.7116 2.1875 13.4375C2.1875 15.1634 3.58661 16.5625 5.3125 16.5625Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleThree);
export default __webpack_public_path__ + "static/media/circle-three.63f1dd5464b64ebe76490c3200417690.svg";
export { ForwardRef as ReactComponent };